import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postIssuePersonal = (params) => {
    return axios.post(`${backendHost}/api/admin/bonuses/personal/issue`, params);
};

export {
    postIssuePersonal
}